export default "__VITE_ASSET__e3$OShRo__"